import styled from '@emotion/styled';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { sort } from 'ramda';
import React, { useMemo } from 'react';

import assessmentSettingsPropType from '../../types/assessmentSettings';
import questionPropType from '../types/questionPropType';
import AssessmentManagerQuestion from './AssessmentManagerQuestion';

const QuestionGroupStyle = styled.div`
    border: 1px solid var(--brandInfo);
    margin-top: 16px;
    margin-bottom: 16px;
`;

const QuestionGroupHeader = styled.div`
    background-color: var(--brandInfo);
    color: white;
    padding: 6px;
`;

const QuestionGroupBody = styled.div`
    padding: 15px;
`;

const AssessmentManagerQuestionGroup = ({ group, questions, assessment }) => {
    const sortedQuestions = useMemo(
        () =>
            sort((a, b) => {
                const aHasVersion = !!a.version_id;
                const bHasVersion = !!b.version_id;
                if (!aHasVersion && !bHasVersion) {
                    // When both do not have version_id put newest ones first
                    return -1;
                }
                return Number(aHasVersion) - Number(bHasVersion);
            }, questions),
        [questions]
    );

    return (
        <QuestionGroupStyle style={{ borderColor: !group.id ? 'transparent' : undefined }}>
            {!!group.id && <QuestionGroupHeader>{group.name} Questions</QuestionGroupHeader>}

            <QuestionGroupBody>
                {sortedQuestions.map((question, index) => (
                    <AssessmentManagerQuestion
                        key={question.question_id}
                        questionId={question.question_id}
                        questionIndex={index}
                        assessment={assessment}
                    />
                ))}
            </QuestionGroupBody>
        </QuestionGroupStyle>
    );
};

AssessmentManagerQuestionGroup.propTypes = {
    group: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    }).isRequired,
    questions: PropTypes.arrayOf(questionPropType).isRequired,
    assessment: assessmentSettingsPropType.isRequired,
};

export default React.memo(AssessmentManagerQuestionGroup, isEqual);
